import PropTypes from 'prop-types';
import React from 'react';

function Plug(props) {
  const { fill } = props;

  return (
    <svg
      fill="none"
      height="24"
      style={{ fill: 'none' }}
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_7841_54075)">
        <path
          d="M9.04014 12.9342C8.10105 11.9951 7.53541 10.7595 7.46765 9.49917C7.39989 8.23886 7.83556 7.05708 8.67882 6.21382L10.2686 4.62405C10.4794 4.41323 10.7748 4.30432 11.0899 4.32126C11.405 4.3382 11.7139 4.4796 11.9487 4.71439L17.26 10.0256C17.4947 10.2604 17.6361 10.5693 17.6531 10.8844C17.67 11.1995 17.5611 11.4949 17.3503 11.7057L15.7605 13.2955C14.9172 14.1388 13.7355 14.5744 12.4752 14.5067C11.2148 14.4389 9.97923 13.8733 9.04014 12.9342Z"
          stroke={fill}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.25"
        />
        <path
          d="M7.52295 10.9109L6.66411 11.7698C6.42236 12.0115 6.28374 12.3367 6.27879 12.6737C6.27384 13.0106 6.40297 13.3318 6.63775 13.5666L8.40817 15.337C8.64293 15.5718 8.96412 15.7009 9.3011 15.696C9.63805 15.691 9.9632 15.5524 10.205 15.3106L11.0638 14.4518"
          stroke={fill}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.25"
        />
        <path
          d="M13.087 5.34681L15.3633 3.07056"
          stroke={fill}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.25"
        />
        <path
          d="M16.6276 8.88764L18.9038 6.61139"
          stroke={fill}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.25"
        />
        <path
          d="M7.47238 14.5022L5.95487 16.0197C5.47191 16.5027 5.19526 17.1524 5.18577 17.8259C5.17628 18.4995 5.43474 19.1416 5.90428 19.6112C6.37383 20.0807 7.016 20.3392 7.68952 20.3297C8.36304 20.3202 9.01275 20.0435 9.49571 19.5606C9.97867 19.0776 10.6284 18.801 11.3019 18.7915C11.9754 18.782 12.6176 19.0404 13.0871 19.51C13.5567 19.9795 13.8151 20.6217 13.8057 21.2952"
          stroke={fill}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.25"
        />
      </g>
      <defs>
        <clipPath id="clip0_7841_54075">
          <rect fill="white" height="24" width="24" />
        </clipPath>
      </defs>
    </svg>
  );
}

Plug.propTypes = {
  fill: PropTypes.string.isRequired
};

export default Plug;
